import React, { Component } from "react";
import { notification } from "antd";
import Header from "../../../User/Header";
import { GlobalContext } from "../../../app/providers/GlobalState";
import axios from "axios";
import moment from "moment";
import Evento from "./Evento";
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class Eventos extends Component {
    static contextType = GlobalContext;
    state = {
        eventos: [],
        //LOADING
        iconLoading: false,
        countNum: 0
    };

    UNSAFE_componentWillMount() {
        this.listar();
    }

    componentDidUpdate() {
        this.state.count = this.state.countNum;
    }

    listar = () => {
        this.setState({
            iconLoading: true
        });
        axios({
            method: "get",
            url: "/api/pagina-entidade/listar-eventos",
            params: {
                entidadeUrl: this.props.match.params.entidade,
                count: this.state.countNum
            }
        })
            .then(response => {
                this.setState({
                    eventos: [...this.state.eventos, ...response.data.eventos],
                    fim: response.data.fim,
                    iconLoading: false
                });
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar eventos");
                this.setState({
                    iconLoading: false
                });
            });
    };

    incrementar = () => {
        this.setState({ countNum: this.state.countNum + 1 }, () => {
            this.listar();
        });
    };

    render() {
        const { eventos, fim, iconLoading } = this.state;

        return (
            <>
                <Header titulo="Eventos" />
                <div className="lista-noticias">
                    <div className="lista">
                        {eventos.map(evento => (
                            <Evento evento={evento} />
                        ))}
                    </div>
                    {!fim ? (
                        <div style={{ display: "flex", justifyContent: "center", padding: 40 }}>
                            <button className="botao-secundario btn-load-more" disabled={iconLoading} onClick={this.incrementar}>
                                {!iconLoading ? "Ver mais" : "A carregar..."}
                            </button>
                        </div>
                    ) : null}
                </div>
            </>
        );
    }
}
export default Eventos;
